import React from 'react';
import {type CellContext, type RowData} from '@tanstack/react-table';
import {useArrowFocusTrapItem} from '@netx/core-components/ArrowFocusTrapNext';
import {Switch, type SwitchProps} from '@netx/core-components/Switch';
import {silenceEvent, stopPropagation} from '@netx/core-next/utils/browser';
import {splitEventHandler} from '@netx/core-next/utils/fn';

export interface SwitchCellProps<TData extends RowData>
	extends CellContext<TData, any> {
	SwitchProps?: Partial<SwitchProps>;
}

const SwitchCellPrimitive = <TData extends RowData>({
	SwitchProps,
	...props
}: SwitchCellProps<TData>) => {
	const arrowFocusTrapItem = useArrowFocusTrapItem({
		index: props.row.index,
	});

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div onMouseDown={stopPropagation}>
			<Switch
				tabIndex={arrowFocusTrapItem.attributes.tabIndex}
				{...SwitchProps}
				onBlur={splitEventHandler(
					SwitchProps?.onBlur,
					arrowFocusTrapItem.actionAttributes.onBlur,
				)}
				onChange={splitEventHandler(SwitchProps?.onChange, silenceEvent)}
				onClick={splitEventHandler(
					SwitchProps?.onClick,
					stopPropagation,
					(event) => {
						arrowFocusTrapItem.setActive();
					},
				)}
				onFocus={splitEventHandler(
					SwitchProps?.onFocus,
					arrowFocusTrapItem.actionAttributes.onFocus,
				)}
			/>
		</div>
	);
};

export const SwitchCell = SwitchCellPrimitive;
export default SwitchCell;
